import { RouteProps } from 'react-router';
import SWP from '.';
import SWPMain from './SWPMain';
import SWPOtp from './SWPOtp';
import SWPSuccess from './SWPSuccess';

export const SWPPaths = {
    SWP: '/swp',
    SWPMain: '/swp/:isin',
    otp: '/swpt/verify-otp',
    success: '/swpt/success',
};

export const routes: RouteProps[] = [
    {
        path: SWPPaths.SWP,
        component: SWP,
        exact: true,
    },
    {
        path: SWPPaths.SWPMain,
        component: SWPMain,
    },
    {
        path: SWPPaths.otp,
        component: SWPOtp,
    },
    {
        path: SWPPaths.success,
        component: SWPSuccess,
    },
];

export { routes as SWPRoutes };
